import { Array } from "@siteimprove/alfa-array";
/**
 * @public
 */
export function hasTabIndex(predicateOrNumber = () => true, ...rest) {
    const predicate = typeof predicateOrNumber === "number"
        ? (n) => Array.append(rest, predicateOrNumber).includes(n)
        : predicateOrNumber;
    return (element) => element.tabIndex().some(predicate);
}
//# sourceMappingURL=has-tab-index.js.map